var map = {
	"./AuthPage": 106,
	"./AuthPage.tsx": 106,
	"./ClerkOrderPage": 159,
	"./ClerkOrderPage.tsx": 159,
	"./ClerkOrderStatusPage": 163,
	"./ClerkOrderStatusPage.tsx": 163,
	"./ClerkPaymentPage": 164,
	"./ClerkPaymentPage.tsx": 164,
	"./ClerkTablePage": 165,
	"./ClerkTablePage.tsx": 165,
	"./CustomerPage": 104,
	"./CustomerPage.tsx": 104,
	"./KitchenOrderPage": 162,
	"./KitchenOrderPage.tsx": 162,
	"./ManageDishPage": 161,
	"./ManageDishPage.tsx": 161,
	"./PageNotFound": 107,
	"./PageNotFound.tsx": 107,
	"./PaymentCustomerPage": 105,
	"./PaymentCustomerPage.tsx": 105,
	"./ProfilePage": 166,
	"./ProfilePage.tsx": 166,
	"./QRPage": 103,
	"./QRPage.tsx": 103,
	"./Template": 160,
	"./Template.tsx": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;